import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import HBText from '../HBText/HBText';
import { HBCornerBadgePosition } from '../HBCornerBadge/HBCornerBadge';

const BADGE_HEIGHT = 20;
const HORIZONTAL_PADDING = 6;
const BADGE_SIDE_BORDER_RADIUS = 8;
const BADGE_SIDE_ROTATION = 11;
const BADGE_SIDE_SPACING = -9;

const getPositionSpecificStyles = (position?: HBCornerBadgePosition) => {
    switch (position) {
        case 'topRight':
            return css`
                right: 0;
                flex-direction: row;
                padding-right: ${HORIZONTAL_PADDING}px;

                ${CornerBadgeSide} {
                    left: ${BADGE_SIDE_SPACING}px;
                    transform: skew(${BADGE_SIDE_ROTATION}deg);
                    border-radius: 0 0 0 ${BADGE_SIDE_BORDER_RADIUS}px;
                }
            `;
        case 'topLeft':
            return css`
                left: 0;
                flex-direction: row-reverse;
                padding-left: ${HORIZONTAL_PADDING}px;

                ${CornerBadgeSide} {
                    right: ${BADGE_SIDE_SPACING}px;
                    transform: skew(-${BADGE_SIDE_ROTATION}deg);
                    border-radius: 0 0 ${BADGE_SIDE_BORDER_RADIUS}px 0;
                }
            `;
        default:
            return;
    }
};

export const CornerBadgeSide = styled.div`
    width: 12px;
    height: ${BADGE_HEIGHT}px;
    background-color: ${vars.colors.base.accent};
    position: absolute;
`;

export const CornerBadgeText = styled(HBText)`
    color: ${vars.colors.text.invertedPrimary};
    position: relative;
    font-weight: 600;
    font-size: 12px;
`;

export const CornerBadgeWrapper = styled.div<{
    position?: HBCornerBadgePosition;
}>`
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    background-color: ${vars.colors.base.accent};
    height: ${BADGE_HEIGHT}px;

    ${props => getPositionSpecificStyles(props.position)}
`;
